import script from "./special-agreement.vue?vue&type=script&lang=ts&setup=true"
export * from "./special-agreement.vue?vue&type=script&lang=ts&setup=true"

import "./special-agreement.vue?vue&type=style&index=0&id=62c9b928&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c9b928"]])

export default __exports__